import type { IconData } from '@stacksjs/iconify-core'

export const graphDotSolid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M5 3a2 2 0 1 0-4 0c0 16.326.302 32.346.437 38.692a4.97 4.97 0 0 0 4.87 4.871C12.655 46.698 28.675 47 45 47a2 2 0 1 0 0-4c-16.284 0-32.272-.301-38.607-.436a.97.97 0 0 1-.957-.957c-.031-1.454-.07-3.417-.114-5.775c2.294-4.322 5.56-8.923 8.296-12.49c.461-.6.906-1.171 1.327-1.703A6 6 0 0 0 17 22c1.05 0 2.036-.27 2.894-.743c2.116 1.72 4.309 3.316 6.218 4.637q.54.375 1.049.72a6 6 0 1 0 9.35-3.479a169 169 0 0 1 3.235-9.14Q39.872 14 40 14a6 6 0 1 0-3.966-1.497q-.227.591-.468 1.229a172 172 0 0 0-2.894 8.277a5.97 5.97 0 0 0-3.34 1.243q-.46-.311-.944-.646a99 99 0 0 1-5.83-4.34a6 6 0 1 0-10.699.827a152 152 0 0 0-1.415 1.815c-1.636 2.133-3.494 4.674-5.246 7.345C5.093 20.995 5 12.043 5 3\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default graphDotSolid
